import React, { useState } from "react";

import { CardHeading } from "@/components/UI/Headings";
import CardSecondary from "@/components/UI/Card/CardSecondary";
import images from "@/utils/images";

import { CarePlanCreation } from "./components/CarePlanCreation";

const LegacyCarePlan = ({ isPatientInactive, patientId }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {isOpen && (
        <CarePlanCreation
          close={() => setIsOpen(false)}
          isPatientInactive={isPatientInactive}
          patientId={patientId}
        />
      )}

      <CardSecondary
        className="PatientProfile__CreatePlan-wpr py-4 d-xl-flex d-block justify-content-between align-items-center px-3 px-xl-4"
        style={{ maxWidth: "100%" }}
      >
        <div className="d-flex align-items-center" style={{ maxWidth: "65%" }}>
          <img
            alt="90 Days Plan"
            className="PatientProfile__90DaysPlan img-fluid"
            src={images("./common/90DaysPlan.svg")}
            width="39px"
          />

          <div className="ml-2 pl-2 mr-0 mr-lg-5">
            <CardHeading className="text-white d-lg-inline-block fs-16" text="Legacy Care Plan" />
            <p className="text-white fs-14">
              To support our transition to the new Care Plan, goals and objectives previously
              entered here will be temporarily retained in view-only mode.
            </p>
          </div>
        </div>

        <div className="ml-auto mt-3 mt-lg-0">
          <div className="d-block text-right">
            <span
              className="ClinicalAssessment_Btn Btn Btn--pri Btn-sm"
              onClick={() => setIsOpen(true)}
              style={{ color: "white", cursor: "pointer" }}
            >
              Care Plan Details
            </span>
          </div>
        </div>
      </CardSecondary>
    </>
  );
};

export default LegacyCarePlan;
